module["exports"] = [
  "United States",
  "United States of America",
  "USA"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_US/address/default_country.js
// module id = 1139
// module chunks = 0